import React from "react";
import { Tag, Tooltip } from "antd";
import { WarningOutlined } from "@ant-design/icons";

export const DEFAULT_SCHEDULE_TAG_COLOR = "#8C8C8C";

export function resolveScheduleTagDefinition(tagName, definitionMap) {
    return definitionMap?.get(String(tagName || "").trim().toLocaleLowerCase()) || null;
}

export const ScheduleTag = ({
    name,
    definitionMap,
    loadError = null,
    showInactive = true,
    closable = false,
    onClose,
    onMouseDown,
    style,
}) => {
    const definition = resolveScheduleTagDefinition(name, definitionMap);
    const inactive = Boolean(definition && !definition.is_active);
    const tag = (
        <Tag
            color={definition?.color_code || DEFAULT_SCHEDULE_TAG_COLOR}
            closable={closable}
            onClose={onClose}
            onMouseDown={onMouseDown}
            style={{ marginBottom: 4, ...style }}
        >
            {name}
            {showInactive && inactive ? " (已停用)" : ""}
            {loadError ? <WarningOutlined aria-label="标签颜色配置未加载" style={{ marginLeft: 4 }} /> : null}
        </Tag>
    );

    if (loadError) {
        return <Tooltip title="标签颜色配置未加载，已使用默认颜色">{tag}</Tooltip>;
    }
    if (inactive) {
        return <Tooltip title="该标签已停用，仅保留历史计划展示">{tag}</Tooltip>;
    }
    return tag;
};

export default ScheduleTag;
